import {gql, useQuery} from '@apollo/client';
import {ZeroAddress} from 'ethers';
import {assetManagerSubgraph} from '@/providers/subgraph/subgraph';

export type AssetManager = {
  id: string;
};

export type AssetManagerPosition = {
  shares: string;
  assetManager: AssetManager;
};

export type Transaction = {
  assetManager: AssetManager;
  shares: string;
  tx: string;
  timestamp: number;
};

export type Account = {
  assetManagers: AssetManagerPosition[];
  transactions: Transaction[];
};

export type AccountAssetManagerData = {
  account: Account | null;
};

export const useAssetManagerData = (account?: string) => {
  return useQuery<AccountAssetManagerData>(
    gql`
      query AssetManagerAccountData($account: String!) {
        account(id: $account) {
          assetManagers(where: {shares_gt: 0}) {
            shares
            assetManager {
              id
            }
          }
          transactions(first: 1000, orderBy: timestamp, orderDirection: desc) {
            assetManager {
              id
            }
            shares
            tx
            timestamp
          }
        }
      }
    `,
    {
      client: assetManagerSubgraph,
      fetchPolicy: 'cache-first',
      variables: {
        account: account?.toLowerCase() || ZeroAddress,
      },
      pollInterval: 3600000, // 1 hour in milliseconds
    }
  );
};
